// extracted by mini-css-extract-plugin
export default {"richTextEditor":"richText_richTextEditor__R8sue"};